import React, { useState, useEffect } from "react";
import ProductSelectFieldComponent from "./productSelectField.component";
import ProductSelectPanelComponent from "./productSelectPanel.component";
import { useSelector } from "react-redux";

function ProductSelectFieldContainer({
  value,
  placeholder,
  searchPlaceholder,
  emptyMessage,
  dropdownItem,
  handleChange,
  disabled,
  isFetching,
  panelStyle,
  anchorOrigin,
  transformOrigin,
  PaperProps,
  style,
  textStyle,
  isEmpty,
  searchable,
}) {
  const lang = useSelector((state) => state.constant.languages);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [productList, setProductList] = useState(dropdownItem);

  useEffect(() => {
    setProductList(dropdownItem);
  }, [dropdownItem]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    handleSearch("");
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSearch = (targetProduct) => {
    if (targetProduct.trim().length === 0) {
      setProductList(dropdownItem);
      return;
    }
    let products = [];
    dropdownItem.forEach((product) => {
      let productName = product.name ?? "";
      if (productName.toLowerCase().includes(targetProduct.toLowerCase())) {
        products.push(product);
      }
    });

    setProductList(products);
  };

  const selectedValue = (selectedValue, index) => {
    if (isEmpty) {
      return false;
    }

    return false;
  };

  return (
    <>
      <ProductSelectFieldComponent
        handleClick={handleClick}
        value={value}
        isEmpty={isEmpty}
        style={style}
        disabled={disabled}
        placeholder={placeholder}
        open={open}
        textStyle={textStyle}
        lang={lang}
      />
      <ProductSelectPanelComponent
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        searchable={searchable}
        style={panelStyle}
        items={productList}
        handleSearch={handleSearch}
        isFetching={isFetching}
        handleChange={handleChange}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        PaperProps={PaperProps}
        value={value}
        selectedValue={selectedValue}
        emptyMessage={emptyMessage}
        placeholder={searchPlaceholder}
      />
    </>
  );
}

export default ProductSelectFieldContainer;
